import React from 'react'

// Account Interest And Limit

class AccountInfo extends React.Component {

  otherAccount: {}

  componentWillMount(){
    var combineAccount = [
      ...this.props.otherAccounts,
      ...this.props.newAccounts
    ]
    var otherAccountss = combineAccount.filter(item => item.id === this.props.accountId)[0]

    this.otherAccount = otherAccountss
  }

  render(){
    return(
      <dl className="cc-detail-section__content__list">

        <dt>
        {
          this.otherAccount !== undefined ?
          (<div><span>{this.otherAccount.accountType !== undefined ? this.props.accountCountryList !== undefined
            ? this.props.getCountryTaxonomy(this.otherAccount).accountType.name+ ',' :this.otherAccount.accountType.name + ',' : ''}</span>
          <span>{this.otherAccount.accountNumber !== undefined && this.otherAccount.accountNumber !== '' ? this.otherAccount.accountNumber + ',' : ''}</span>
          <span>{this.otherAccount.branchCode !== undefined ? this.otherAccount.branchCode + ',': ''}</span>
          <span>{this.otherAccount.country !== undefined ? this.props.accountCountryList !== undefined
                ? this.props.getCountryTaxonomy(this.otherAccount).country.name+ ',' :this.otherAccount.country.name + ',' : ''}</span>
          <span>{this.otherAccount.currency !== undefined ? this.otherAccount.currency.name : ''}</span></div>):''
        }

        </dt>
        <dd>&nbsp;</dd>
        <dt>{
          this.otherAccount !== undefined ?
          (<div><span>{this.otherAccount.accountHolder !== undefined ? this.otherAccount.accountHolder.name : ''}</span>
</div>):''}
        </dt>
        <dd>&nbsp;</dd>
        <dt>{
          this.otherAccount !== undefined ?
            (<div><span>{this.otherAccount.hsbcBankName !== undefined ? this.otherAccount.hsbcBankName.name + ',' : ''}</span>
          <span>{this.otherAccount.bankName !== undefined && this.otherAccount.bankName !== '' ? this.otherAccount.bankName + ',': ''}</span>
          <span>{this.otherAccount.accountTitle !== undefined ? this.otherAccount.accountTitle : ''}</span>
          <span>{this.otherAccount.tempRefrenceId !== undefined ? `(${this.otherAccount.tempRefrenceId})` : ''}</span>

          </div>):''}
        </dt>
        <dd>&nbsp;</dd>
      </dl>
    )
  }
}

const AccountInterestLimit = ({data,pageJson,pageJsonOth,pageJsonOth1,translations,translateWordForOption,newAccounts,accountCountryList,getCountryTaxonomy}) => (
  <div className="cc-detail-section clearfix">
    <div className="cc-detail-section__heading">{`4. ${translations(pageJsonOth1.pageHeading)}`}</div>
    {
      (data !== undefined && data.cashConcentration !== undefined) ? data.cashConcentration.accountInterestLimits.map((item,key) => (
        <div className="cc-detail-section__content clearfix" key={key}>
          {
            data.otherAccounts.length > 0 &&
            <AccountInfo accountId={item.accountId} otherAccounts={data.otherAccounts} accountCountryList = {accountCountryList} getCountryTaxonomy = {getCountryTaxonomy} newAccounts={newAccounts !== undefined && newAccounts.length > 0 ? newAccounts : []}/>
          }
          <hr/>
          <div className="cc-detail-section__content__heading">{translations(pageJson.creditBalance)}</div>
          <dl className="cc-detail-section__content__list">
            <dt>{translations(pageJsonOth.baseRate)}</dt>
            {
	            item.credit !== undefined
            	? <dd>{item.credit.baseRate}</dd>
            	: <dd>&nbsp;</dd>
            }
            <dt>{translations(pageJsonOth.code)}</dt>
            {
	            item.credit !== undefined
            	? <dd>{item.credit.baseRateCode}</dd>
            	: <dd>&nbsp;</dd>
            }
            <dt>{translations(pageJsonOth.spread)}</dt>
            {
              item.credit !== undefined
            	? <dd>{item.credit.spread}</dd>
            	: <dd>&nbsp;</dd>
            }
            <dt>&nbsp;</dt>
            <dd>
              {
                item.credit !== undefined ?
                  `${item.credit.rate === "true"
                    ? translations(pageJson.margin)
                    : translations(pageJson.fixed)}`
                : ''
              }
            </dd>
            <dt>{translations(pageJson.maxInterest)}</dt>
            {
	            item.credit !== undefined
            	? <dd>{item.credit.maximumInterest}</dd>
            	: <dd>&nbsp;</dd>
            }
            <dt>{translations(pageJson.minInterest)}</dt>
            {
	            item.credit !== undefined
            	? <dd>{item.credit.minimumInterest}</dd>
            	: <dd>&nbsp;</dd>
            }
          </dl>

          <div className="cc-detail-section__content__heading">{translations(pageJson.debitBalance)}</div>
          <dl className="cc-detail-section__content__list">
            <dt>{translations(pageJsonOth.baseRate)}</dt>
            {
	            item.debit !== undefined
            	? <dd>{item.debit.baseRate}</dd>
            	: <dd>&nbsp;</dd>
            }
            <dt>{translations(pageJsonOth.code)}</dt>
            {
	            item.debit !== undefined
            	? <dd>{item.debit.baseRateCode}</dd>
            	: <dd>&nbsp;</dd>
            }
            <dt>{translations(pageJsonOth.spread)}</dt>
            {
	            item.debit !== undefined
            	? <dd>{item.debit.spread}</dd>
            	: <dd>&nbsp;</dd>
            }
            <dt>&nbsp;</dt>
            <dd>
              {
                item.debit !== undefined
                ? `${item.debit.rate === "true"
                  ? translations(pageJson.margin)
                  : translations(pageJson.fixed)}`
                : ''
              }
            </dd>
            <dt>{translations(pageJson.maxInterest)}</dt>
            {
	            item.debit !== undefined
            	? <dd>{item.debit.maximumInterest}</dd>
            	: <dd>&nbsp;</dd>
            }
            <dt>{translations(pageJson.minInterest)}</dt>
            {
	            item.debit !== undefined
            	? <dd>{item.debit.minimumInterest}</dd>
            	: <dd>&nbsp;</dd>
            }
          </dl>
          <hr />
          <dl className="cc-detail-section__content__list">
            <dt>{translations(pageJson.setOdLimit)}</dt>
            <dd>{item.odLimit}</dd>
            {
              item.odLimit !== 'N/A'
              ? [
                  <dt>{'Unauthorised Interested Type'}</dt>,
                  <dd>{item.unauthorizedInterestType}</dd>
                ]
              : ''
            }
          </dl>
          {
            item.odLimit !== 'N/A'
            ? <div className="cc-detail-section__content__heading">{translations(pageJson.unauthorisedOd)}</div>
            : ''
          }
          {
            item.odLimit !== 'N/A'
            ? <dl className="cc-detail-section__content__list">
                <dt>{translations(pageJsonOth.baseRate)}</dt>
                {
    	            item.unauthorizedOD !== undefined
                	? <dd>{item.unauthorizedOD.baseRate}</dd>
                	: <dd>&nbsp;</dd>
                }
                <dt>{translations(pageJsonOth.code)}</dt>
                {
    	            item.unauthorizedOD !== undefined
                	? <dd>{item.unauthorizedOD.baseRateCode}</dd>
                	: <dd>&nbsp;</dd>
                }
                <dt>{translations(pageJsonOth.spread)}</dt>
                {
    	            item.unauthorizedOD !== undefined
                	? <dd>{item.unauthorizedOD.spread}</dd>
                	: <dd>&nbsp;</dd>
                }
                <dt>
                  {
                      item.unauthorizedOD !== undefined
                      ? `${item.unauthorizedOD.rate === "true"
                        ? translations(pageJson.margin)
                        : translations(pageJson.fixed)}`
                      : ''
                  }
                </dt>
                <dd>&nbsp;</dd>
                <dt>{translations(pageJson.maxInterest)}</dt>
                {
    	            item.unauthorizedOD !== undefined
                	? <dd>{item.unauthorizedOD.maximumInterest}</dd>
                	: <dd>&nbsp;</dd>
                }
                <dt>{translations(pageJson.minInterest)}</dt>
                {
    	            item.unauthorizedOD !== undefined
                	? <dd>{item.unauthorizedOD.minimumInterest}</dd>
                	: <dd>&nbsp;</dd>
                }
              </dl>
            : ''
          }

          <hr />
          <dl className="cc-detail-section__content__list">
            <dt>{translations(pageJson.setAccount)}</dt>
            <dd>{item.accountLimit === true ? "Yes" : "No"}</dd>
            {
              item.accountLimit === true
              ? [
                  <dt>{translations(pageJson.limitType)}</dt>,
                  <dd>{translations(pageJson.accountLimit)}</dd>,
                  <dt>{translations(pageJson.currency)}</dt>,
                  <dd>{item.currency}</dd>,
                  <dt>{translations(pageJson.lendingLimit)}</dt>,
                  <dd>{item.lendingLimit}</dd>,
                  <dt>{translations(pageJsonOth.lendingLimitBreachAction)}</dt>,
                  <dd>{item.lendingLimitBreachAction !== undefined ? item.lendingLimitBreachAction.name : ''}</dd>,
                  <dt>{translations(pageJson.borrowingLimit)}</dt>,
                  <dd>{item.borrowingLimit}</dd>
              ]
              : ''
            }
            <dt>{translations(pageJson.breachAction)}</dt>
            {
	            item.borrowingLimitBreachAction !== undefined
            	? <dd>{item.borrowingLimitBreachAction.name}</dd>
            	: <dd>&nbsp;</dd>
            }
          </dl>
        </div>
      )):''
    }
  </div>
)

export default AccountInterestLimit;



// WEBPACK FOOTER //
// ./src/components/CaseList/PreviewGLS/CCPreview/AccountInterestLimit.js